import { Link } from "react-router-dom";
import { services } from "@/mocks/site/content";

export default function ServicesGrid() {
  return (
    <section className="py-20 md:py-28 bg-cream-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
              What we move
            </div>
            <h4 className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-tight tracking-tight">
              <a href="#services" className="text-ink-900 hover:text-ink-900 no-underline">
                Every move, handled like the only one we have today.
              </a>
            </h4>
          </div>
          <Link
            to="/site/services"
            className="inline-flex items-center gap-2 text-sm font-semibold text-ink-900 hover:text-brand-600 cursor-pointer whitespace-nowrap self-start md:self-end"
          >
            See all services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div id="services" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {services.map((service) => (
            <Link
              key={service.id}
              to="/site/services"
              className="group relative bg-white rounded-xl p-6 md:p-7 border border-ink-100 hover:border-brand-300 transition-all cursor-pointer overflow-hidden"
            >
              {/* Top accent bar */}
              <div
                className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${service.color} opacity-0 group-hover:opacity-100 transition-opacity`}
              ></div>

              <div
                className={`w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.color} text-white mb-5 group-hover:scale-105 transition-transform`}
              >
                <i className={`${service.icon} text-2xl`}></i>
              </div>

              <div className="flex items-start justify-between gap-3 mb-2">
                <h3 className="font-display text-xl font-bold text-ink-900 leading-tight">
                  {service.title}
                </h3>
                <i className="ri-arrow-right-up-line text-ink-300 group-hover:text-brand-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"></i>
              </div>
              <div className="text-xs font-semibold text-brand-600 uppercase tracking-wider mb-3">
                {service.tagline}
              </div>

              <p className="text-sm text-ink-600 leading-relaxed mb-5">{service.description}</p>

              <div className="flex items-center justify-between pt-4 border-t border-ink-100">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.15em] text-ink-400 font-semibold">
                    Starting at
                  </div>
                  <div className="font-display text-xl font-bold text-ink-900">
                    ${service.startingPrice}
                  </div>
                </div>
                <div className="flex flex-wrap gap-1.5 justify-end max-w-[60%]">
                  {service.features.slice(0, 2).map((f) => (
                    <span
                      key={f}
                      className="text-[10px] font-semibold px-2 py-1 rounded bg-cream-100 text-ink-700"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}